<template>
  <a class="gameLinkButton" :href="url" :download="isDownloadLink" v-html="content"></a>
</template>

<script>
export default {
  name: 'GameLinkButton',
  props: ['linkData'],
  computed:{
    content: function(){
      var content = "";
      if(this.linkData){
        switch(this.linkData.platform){
          case 'windows':
            content = "Windows版";break;
          case 'mac': 
            content = "MacOS版";break;
        }
        content += "<br>" + this.linkData.text;
      }
      return content;
    },
    url: function(){
      if(this.linkData) 
        return this.linkData.URL;
      else
        return '';
    },
    isDownloadLink: function(){
      return this.linkData &&  this.linkData.type == "download";
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*スマートフォン・タブレットデザイン*/
.gameLinkButton{
    display: inline-block;
    width: 65%;
    font-size: 1.5em;
    text-decoration: none;
    color: white;
    background-color: lightblue;
    border-radius: 5px;
    box-shadow: 2px 2px 2px cyan;
    margin: 5px auto;
}

/*PC向けデザイン*/
@media screen and (min-width: 1280px){
  .gameLinkButton{
    width: 250px;
    font-size: 30px;
  }
}
</style>
